import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/angularjs';

import { CompanyService }    from '../companies/company.service';
import { ConfirmService }    from '../messages/confirm/confirm.service';
import { DvlaLookupService } from './dvla-lookup.service';
import { MessagesService }   from '../messages/messages.service';

@Component({
  selector   : 'wor-dvla-lookup-settings',
  template: require('./dvla-lookup.settings.component.html')
})
export class DvlaLookupSettingsComponent {
  @Input() availableRequests: number;

  title = this.dvlaLookupService.title;

  constructor (
    public  companyService   : CompanyService,
    private confirmService   : ConfirmService,
    private dvlaLookupService: DvlaLookupService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService
  ) {}

  activate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.title
    }))
    .then(() => this.dvlaLookupService.activate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
      name: this.title
    }))
    .then(() => this.dvlaLookupService.deactivate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  purchase () : void {
    this.dvlaLookupService.purchase()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
